export enum EScrollRegistryKeys {
  DAP_PAGE_ERROR = 'dapPageError',
  PRODUCT_ERROR_MESSAGE = 'productErrorMessage',
  INPUT_GROUP = 'inputGroup',
  COMMON = 'common',
}
